import client from './client';

export const categoryGetHomePage = () => client().get('/Category/GetForHomePage');

export const categoryBannerDataGet = () => client().get('/Category/GetAll');
